import { render, staticRenderFns } from "./StatisticsStatusTotalCosts.vue?vue&type=template&id=71ecfa40&"
import script from "./StatisticsStatusTotalCosts.vue?vue&type=script&lang=js&"
export * from "./StatisticsStatusTotalCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports